import React from 'react';
import { Provider } from 'react-redux';
import { StickyContainer, Sticky } from 'react-sticky';

import store from './redux/store.js';
import Base from './screens/base.js'
import './App.css';
import exclamation from './assets/exclamation.png';

function App() {
  return (
    <Provider store={store}>
      <StickyContainer>
        <Sticky>
          {({
            style
          }) => (
            <div style={{...style, display: 'flex', backgroundColor: '#FFFF99', textAlign: 'center', height: 30, alignItems: 'center', justifyContent: 'center', zIndex: 2}}>
              <img src={exclamation} alt="exclamation" height='16' width='16' />
              Website is still under construction
            </div>
          )}
        </Sticky>
        <Base />
      </StickyContainer>
    </Provider>
  );
}

export default App;
